export enum ConversationLogStatus {
  DRAFT = "DRAFT",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

export interface ConversationMessage {
  sender: string;
  text: string;
  timestamp: string;
}

export interface ConversationLog {
  id?: number;
  knowledgeBaseId?: number;
  assistantId?: string;
  threadId?: string;
  channel: string;
  messages: ConversationMessage[];
  messageCount?: number;
  status?: ConversationLogStatus;
  startTime?: string;
  endTime?: string;
  createdAt?: string;
  updatedAt?: string;
}
